import script from "./ResumeLicenceDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResumeLicenceDetail.vue?vue&type=script&setup=true&lang=ts"

import "./ResumeLicenceDetail.vue?vue&type=style&index=0&id=b40d610a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b40d610a"]])

export default __exports__